$('.accordion-main-box').on('click', function () {
    // Check if the current accordion is active
    if ($(this).find('.accordion-head').hasClass('active')) {
        // Close the current accordion
        $(this).find('.accordion-content').slideUp();
        $(this).find('.accordion-head').removeClass('active');
    } else {
        // Close all accordions
        $('.accordion-content').slideUp();
        $('.accordion-main-box .accordion-head').removeClass('active');
        
        // Open the clicked accordion
        $(this).find('.accordion-content').slideDown();
        $(this).find('.accordion-head').addClass('active');
    }
});

// ====================================

AOS.init({
  once:true
});